import { DataKindsRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { CreateFileLayoutRequest, CreateFileLayoutResponse } from ".";

export const useCreateFileLayout = () =>
  useRestResourceHook<CreateFileLayoutRequest, CreateFileLayoutResponse>(
    (request) => DataKindsRestResource.createFileLayout(request),
  );
